import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import { useAuth } from '../contexts/AuthContext';
import NotificationBell from '../components/NotificationBell';

const adminNavLinks = [
  { to: '/admin', label: 'Dashboard', icon: 'dashboard' },
  { to: '/admin/requests', label: 'Requests', icon: 'list' },
  { to: '/admin/team', label: 'Team', icon: 'people' },
  { to: '/admin/settings', label: 'Settings', icon: 'settings' },
];

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r flex flex-col">
        <Logo />
        <nav className="flex-1 px-4 py-6 space-y-2">
          {adminNavLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`flex items-center px-3 py-2 rounded-lg font-medium transition-colors ${
                location.pathname === link.to
                  ? 'bg-gray-100 text-primary'
                  : 'hover:bg-gray-100 text-gray-700'
              }`}
            >
              <span className="material-icons mr-3">{link.icon}</span> {link.label}
            </Link>
          ))}
        </nav>
        <button
          onClick={handleLogout}
          className="m-4 px-4 py-2 rounded bg-red-100 text-red-600 hover:bg-red-200 font-medium flex items-center justify-center"
        >
          <span className="material-icons mr-2">logout</span> Logout
        </button>
      </aside>
      {/* Main Content */}
      <main className="flex-1">
        {/* Header with notifications */}
        <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-gray-900">
            {adminNavLinks.find(link => link.to === location.pathname)?.label || 'Admin Panel'}
          </h1>
          <div className="flex items-center space-x-4">
            <NotificationBell />
            <div className="h-6 w-px bg-gray-300"></div>
            <span className="text-sm text-gray-600">Team Member</span>
          </div>
        </header>
        {children}
      </main>
    </div>
  );
};

export default AdminLayout; 